import gd from "./gd";

export default {
  gd,
};
